import { Skeleton } from "@/components/ui/skeleton";
import StandardDetailLayout from "@/layouts/StandardDetailLayout";

export default function DetailLoadingSkeleton({
  breadcrumbs,
}: {
  breadcrumbs: { label: string; to?: string }[];
}) {
  return (
    <StandardDetailLayout
      breadcrumbs={breadcrumbs}
      title="Đang tải..."
    >
      <div className="space-y-6">
        {/* Info Card Skeleton */}
        <div className="bg-white border border-slate-200 rounded-lg p-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-4 w-1/2" />
            
            <Skeleton className="h-4 w-1/2 col-span-2" />
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-4 w-1/3" />
          </div>
        </div>
        
        {/* Tabs Skeleton */}
        <div className="bg-white border border-slate-200 rounded-lg">
          <div className="border-b border-slate-100 p-2 flex gap-2">
            <Skeleton className="h-8 w-24" />
            <Skeleton className="h-8 w-24" />
            <Skeleton className="h-8 w-24" />
          </div>
          <div className="p-4 space-y-3">
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
          </div>
        </div>
      </div>
    </StandardDetailLayout>
  );
}
